import { Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoCircleIcon from "@mui/icons-material/InfoRounded";
import { ReactNode } from "react";

interface ErrorAlertProps {
  children?: ReactNode;
  floating?: boolean;
}
export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  children,
  floating
}: ErrorAlertProps) => {
  return (
    <Alert
      severity="error"
      variant="outlined"
      classes={{
        root: "form-row error-alert" + (floating ? " floating-alert" : ""),
        message: "success-msg",
        icon: "error-icon",
      }}
      iconMapping={{
        error: <InfoCircleIcon />,
      }}
    >
      {children}
    </Alert>
  );
};

export const SuccessAlert = ({ message }: { message: string }) => {
  return (
    <Alert
      severity={"success"}
      variant="outlined"
      classes={{
        root: "success-alert",
        message: "message",
        icon: "success-icon",
      }}
      iconMapping={{
        success: <CheckCircleIcon />,
      }}
    >
      {message}
    </Alert>
  );
};
